var $3b65c017e2338742$exports = {};
$3b65c017e2338742$exports = {
    "longPressMessage": `Ap\u{103}sa\u{21B}i lung sau ap\u{103}sa\u{21B}i pe Alt + s\u{103}geat\u{103} \xeen jos pentru a deschide meniul`
};


export {$3b65c017e2338742$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
